import { FileArchive, FileText } from 'lucide-react'
import type { Attachment } from '../lib/types'

// Иконка файла по расширению: архивы — FileArchive, остальное — FileText.
export function FileGlyph({ attachment, size = 18 }: { attachment: Attachment; size?: number }) {
  const name = attachment.name.toLowerCase()
  if (/\.(zip|rar|7z|tar|gz)$/.test(name)) {
    return <FileArchive size={size} />
  }
  return <FileText size={size} />
}
